import { createAction } from "redux-actions";
import { CorrectionConstants } from "../constants/correction.constants";

export const newCorrection = createAction(CorrectionConstants.NEW_CORRECTION);
export const updateCorrection = createAction(
    CorrectionConstants.UPDATE_CORRECTION
);
export const submitCorrection = createAction(
    CorrectionConstants.SUBMIT_CORRECTION
);
export const submitCorrectionSuccess = createAction(
    CorrectionConstants.SUBMIT_CORRECTION_SUCCESS
);
export const submitCorrectionFailure = createAction(
    CorrectionConstants.SUBMIT_CORRECTION_FAILURE
);
export const closeCorrection = createAction(
    CorrectionConstants.CLOSE_CORRECTION
);
export const toggleCorrectionReaction = createAction(
    CorrectionConstants.TOGGLE_CORRECTION_REACTION
);
export const toggleCorrectionReactionSuccess = createAction(
    CorrectionConstants.TOGGLE_CORRECTION_REACTION_SUCCESS
);
export const toggleCorrectionReactionFailure = createAction(
    CorrectionConstants.TOGGLE_CORRECTION_REACTION_FAILURE
);
export const submitComment = createAction(CorrectionConstants.SUBMIT_COMMENT);
export const submitCommentSuccess = createAction(
    CorrectionConstants.SUBMIT_COMMENT_SUCCESS
);
export const submitCommentFailure = createAction(
    CorrectionConstants.SUBMIT_COMMENT_FAILURE
);

export const editCorrection = createAction(CorrectionConstants.EDIT_CORRECTION);

export const deleteCorrection = createAction(
    CorrectionConstants.DELETE_CORRECTION
);
export const deleteCorrectionSuccess = createAction(
    CorrectionConstants.DELETE_CORRECTION_SUCCESS
);
export const deleteCorrectionFailure = createAction(
    CorrectionConstants.DELETE_CORRECTION_FAILURE
);

export const reportCorrection = createAction(
    CorrectionConstants.REPORT_CORRECTION
);
export const reportCorrectionSuccess = createAction(
    CorrectionConstants.REPORT_CORRECTION_SUCCESS
);
export const reportCorrectionFailure = createAction(
    CorrectionConstants.REPORT_CORRECTION_FAILURE
);

export const copyLink = createAction(CorrectionConstants.COPY_LINK);

export function determineCorrectionAction(action) {
    switch (action) {
        case "edit":
            return editCorrection;
        case "delete":
            return deleteCorrection;
        case "report":
            return reportCorrection;
        case "copyLink":
            return copyLink;
        default:
            return () => ({
                type: "no-op"
            });
    }
}



// WEBPACK FOOTER //
// ./src/actions/correction.actions.js